import type { Messages } from '@/i18n/types';

/** Vietnam product copy (Nhậu Đee). JA is a secondary locale. */
export const ja: Messages = {
  'lang.label': '言語',

  'nav.primary': 'メインナビゲーション',
  'nav.about': 'Nhậu Đeeとは',
  'nav.features': 'できること',
  'nav.owners': '店舗の方へ',
  'nav.download': 'ダウンロード',
  'nav.downloadCta': 'アプリをダウンロード',
  'nav.openMenu': 'メニューを開く',
  'nav.closeMenu': 'メニューを閉じる',
  'nav.listStore': '店舗を掲載する',
  'nav.stats': '数字で見る',
  'nav.faq': 'よくある質問',

  'hero.headline': '今夜の飲み屋を、すぐ見つける。',
  'hero.sub':
    '空席・近くのお店・現地のつぶやき、そして誰かと飲みたいときのメッセージまで。',
  'hero.ageNote': '18歳未満の飲酒は法律で禁止されています。',
  'hero.phoneAlt': 'Nhậu Đeeアプリのホーム画面。地図で飲み屋を探している様子',

  'store.appStoreKicker': 'App Storeから',
  'store.appStoreName': 'ダウンロード',
  'store.appStoreAria': 'App Storeからダウンロード',
  'store.playKicker': 'Google Playで',
  'store.playName': '手に入れよう',
  'store.playAria': 'Google Playで手に入れよう',

  'about.title': 'ベトナムの飲み場を、もっと探しやすく',
  'about.body':
    'Nhậu Đeeは、今夜空いている飲み屋・ビアホールを見つけるアプリです。地図フィルター、近くのお店一覧、つぶやき、そして仲間と飲むときのメッセージまで、夜の一杯を支えます。',

  'features.eyebrow': 'できること',
  'features.title': 'いい夜に必要な、すべてを',
  'features.summary.01': '地図で探す',
  'features.summary.02': '近くの店',
  'features.summary.03': 'メッセージ',
  'features.summary.04': 'つぶやき',
  'features.01.title': '地図で飲み屋を探す',
  'features.01.body':
    '本日空席や近くの店舗などのフィルターで地図を探索し、今夜空いているお店を見つけられます。',
  'features.01.phoneAlt': '地図で飲み屋・空席フィルターを使っている画面',
  'features.02.title': '近くのお店を一覧で見る',
  'features.02.body':
    '距離と住所つきの写真リストをスクロールして、身近なエリアから迷いなく店を選べます。',
  'features.02.phoneAlt': '近くのお店一覧画面',
  'features.03.title': 'メッセージとCheers',
  'features.03.body':
    '誰かと飲みたいときは、マッチ・チャット・Cheersを確認。はじめての方はプレミアムプランも見られます。',
  'features.03.phoneAlt': 'メッセージとCheersの画面',
  'features.04.title': 'つぶやきを読む',
  'features.04.body':
    '近くのゲスト投稿や評価をチェック。「すべて」「お店」「ユーザー」「日記」で絞り込み、今夜行きたい店のヒントが得られます。',
  'features.04.phoneAlt': 'つぶやきフィード画面',

  'pickup.tag': 'つぶやき',
  'pickup.title': 'テーブルからの本音',
  'pickup.body':
    '料理や待ち時間、店の空気感など、ゲストの短いレビューで次の一杯が少し身近になります。',
  'pickup.imgAlt': '夜の飲み屋。冷たいビールと焼きもの',

  'stats.eyebrow': '数字で見るNhậu Đee',
  'stats.title': '広がる、飲み屋の地図',
  'stats.shops': '掲載店舗数',
  'stats.shopsValue': 'TODO',
  'stats.areas': '対応エリア',
  'stats.areasValue': 'TODO',
  'stats.users': 'ユーザー数',
  'stats.usersValue': 'TODO',
  'stats.note': '※数値は準備中です。公開時に更新します。',

  'safety.eyebrow': '安心のために',
  'safety.title': '誰かと飲むときの、安全の考え方',
  'safety.body':
    'メッセージやCheersは、楽しく、安心してお使いいただけるよう設計しています。',
  'safety.1.title': '本人確認',
  'safety.1.body': 'プロフィールと利用状況に基づく確認フローで、なりすましリスクを抑えます。',
  'safety.2.title': '通報・ブロック',
  'safety.2.body': '気になる相手はすぐに通報・ブロックできます。運営が内容を確認します。',
  'safety.3.title': '年齢確認',
  'safety.3.body': '飲酒を想定したサービスのため、18歳以上の確認を行います。',

  'faq.eyebrow': 'FAQ',
  'faq.title': 'よくある質問',
  'faq.1.q': '料金はかかりますか？',
  'faq.1.a':
    '基本の店舗検索・一覧・つぶやき閲覧は無料でご利用いただけます。メッセージやCheersなど一部機能はプレミアムプランが必要な場合があります。詳細はアプリ内のプラン画面でご確認ください。',
  'faq.2.q': '本当に今夜空いている店が見つかりますか？',
  'faq.2.a':
    '空席や近くの店舗などの情報をもとに探せます。店舗の状況は変わることがあるため、最新の空席表示と店舗ページをご確認ください。',
  'faq.3.q': '安全性や通報機能はありますか？',
  'faq.3.a':
    '誰かと飲む機能では、通報・ブロックに加え、不適切な利用への対応を行っています。困ったときはアプリ内からご連絡ください。',
  'faq.4.q': '店舗を掲載するには？',
  'faq.4.a':
    'オーナーポータルから無料で掲載を始められます。空席状況の共有や投稿、メニュー・スタッフ紹介も行えます。',

  'owners.eyebrow': '店舗オーナーの方へ',
  'owners.title': '今夜の席を探すゲストに届ける',
  'owners.body':
    '店舗を掲載し、今夜の空き状況を共有し、更新を投稿し、メニューとスタッフを紹介——無料で始められます。',
  'owners.cta': 'オーナーポータルを開く',
  'owners.signIn': 'すでにアカウントがある方はログイン',

  'cta.title': '次の一杯を、Nhậu Đeeで',
  'cta.sub': 'アプリをダウンロードして、今夜ぴったりの店を見つけましょう。',
  'cta.ageNote': '18歳未満の飲酒は法律で禁止されています。',

  'footer.inquiry': 'お問い合わせ',
  'footer.social': 'ソーシャル',
  'footer.about': 'Nhậu Đeeとは',
  'footer.owners': '店舗の方へ',
  'footer.help': 'ヘルプ',
  'footer.privacy': 'プライバシー',
  'footer.terms': '利用規約',
  'footer.company': '運営会社',
  'footer.tokusho': '法的情報',
  'footer.age': '18歳未満の飲酒は法律で禁止されています。',
  'footer.facebook': 'Facebook',
  'footer.instagram': 'Instagram',
  'footer.x': 'X',

  'links.contact': 'お問い合わせ',
  'links.privacy': 'プライバシーポリシー',
  'links.terms': '利用規約',
  'links.help': 'ヘルプ',
};
